import { localStorage } from 'utils'
import { getIsAccountFlagEnabled } from 'common/core/selectors/appSelectors'
import { AccountFlag } from 'utils/services/featureFlagsService/constants'

import { LiveChatLocalStorageIds } from '../constants/LiveChatLocalStorageIds'

export const getSelectedLabelId = (state: RootState) => {
  const isLabelsEnabled = getIsAccountFlagEnabled(state, AccountFlag.ENABLE_LC_LABELS)
  if (!isLabelsEnabled) return null

  const savedValue = localStorage.getItem(LiveChatLocalStorageIds.LABEL_FILTER)
  if (savedValue) return Number(savedValue)

  return state.chat.labels.selectedLabelId
}
